import * as React from "react";
import type { SVGProps } from "react";
const SvgMegaphone = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14.48 4c-.61 0-1.18.28-1.557.742-.916 1.123-1.67 1.915-2.543 2.443C9.537 7.696 8.513 8 7 8H4a3 3 0 0 0-3 3v4a1 1 0 1 0 2 0v-4a1 1 0 0 1 1-1h3q.521 0 1-.041V13H5v5a1 1 0 0 0 .293.707l.707.707V20H3v-1a1 1 0 1 0-2 0v3h7v-3.414l-.293-.293L7 17.586V15h2c.938 0 1.427.245 1.895.686.266.251.535.578.867 1.015.117.154.247.33.388.52.232.313.491.663.761 1.013.38.49.964.766 1.57.766H17V4h-2.52M10 13.08c.919.16 1.63.55 2.267 1.15.393.371.744.808 1.089 1.263.147.194.287.384.43.578.215.289.436.588.7.929H15V6h-.52l-.008.007c-.94 1.152-1.873 2.173-3.056 2.889a7 7 0 0 1-1.416.66zm11.947-4.686.895-.447-.895-1.789-.894.448-2 1-.895.447.895 1.789.894-.448zM20 10.5h-1v2h4v-2h-3m-.053 3.106-.894-.448-.895 1.79.895.446 2 1 .894.448.895-1.79-.895-.446z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgMegaphone;
